import { ITaskSearchParam } from '../../../../wisestep-api/dist';

export const TaskDefaultQuery: ITaskSearchParam = {
  searchType: 'team',
  status: 'ALL',
  dueFromDateTime: null,
  dueTillDateTime: null,
  createdFromDateTime: null,
  createdTillDateTime: null,
  updatedFromDateTime: null,
  updatedTillDateTime: null,
  createdBy: [],
  team: [],
  sort: 'due_date',
  sortDirection: 'DESC',
  size: 50,
  page: 0,
  keywords: '',
};
